import { memo, use, useCallback, useContext, useEffect, useMemo, useState } from "react";
import useTileScroller from "../../hooks/useTileScroller";
import { isMobileDevice } from "../../utils/getPlatformInfo";
// import SliderControls from "../SliderControls";
import SliderControls from "./Sliderbutton";
import { UPCOMING } from "./dummyData";
import styles from "./index.module.scss";
// import Rellax from "rellax";
// import lightX from "../../assets/images/lightX.png";
import saveIcon from "../../assets/images/save.png";
import savedIcon from "../../assets/images/saved.png";
import shareIcon from "../../assets/images/share.png";
import infoIcon from "../../assets/images/info.png";
import { webinarContext } from "../../contexts/WebinarContext/WebinarContextProvider";
import moment from "moment";
import { trimString } from "../../utils/common.utils";
import { Box, Shimmer } from "../ShimmerEffect";
import { useHistory, useLocation } from "react-router-dom";
import InviteModal from "../InviteModal/InviteModal";
import { AnalyticsContext } from "../../contexts/Analytics/AnalyticsContextProvider";
import {
  HOME_UPCOMING_WEBINAR_ATTEND_CLICK,
  HOME_UPCOMING_WEBINAR_SHARE_CLICK,
  INVITEYOURFRIEND_EVENT_BTN,
} from "../../AppConstants/AnalyticsEventName";
import { UserContext } from "../../contexts/UserContext/UserContextProvider";
import AllSpeakers from "./AllSpeakers";
import Speakers from "./partials/Speakers";
import { ContentType2, Webinar_status } from "../../AppConstants/TypeConstants";
import ComingSoonWebinarCard from "./ComingSoonWebinarCard/ComingSoonWebinarCard";
import { WEBINAR_PAGE_ROUTE } from "../../AppConstants/Routes";
import AnimatedHeader from "../AnimatedHeader";
import WebinarText from "../../assets/images/webinarBanner.png";
import arrowRight from "../../assets/images/arrow.png";
import arrowLeft from "../../assets/images/arrowOpp.png";
import { getWebinarClickData } from "../../Clevertap/EventHandler.ts";
import { HOME_PAGE_CLICK_EVENT } from "../../Clevertap/EventNames.ts";
import { DOCFLIX_WEBINAR_BACKGROUND_IMAGE } from "../../AppConstants/Constants.js";

function UpcomingWebinars() {
  let history = useHistory();
  const { pathname, search = "", hash = "", state } = useLocation();
  const { webinars, getAllWebinar } = useContext(webinarContext);
  const { user, userMetadata } = useContext(UserContext);
  const { addGAWithUserInfo, addCleverTapAnalytics } =
    useContext(AnalyticsContext);
  const [speakerCardList, setSpeakerCardList] = useState([]);
  const [filteredWebinar, setFilteredWebinar] = useState({
    upcoming: [],
    past: [],
  });

  const [inviteModal, setInviteModal] = useState({
    show: false,
    webinarIndex: 0,
  });

  const [showAllSpeakers, setShowAllSpeakers] = useState({
    show: false,
    speakerIndex: 0,
  });
  const { currentIndex, updateIndex } = useTileScroller({
    // noOfTiles: 4, //webinars.data.length,
    // onEndReached: () => {},
    elementId: "upcoming",
    webTileWidth: 435,
    // mobileTileWidth: 300,
    autoScrollToCard: false,
    webTileId: "upcomingCard",
    indexing: true,
    tileGapWeb: 28,
  });

  useEffect(() => {
    getAllWebinar();
  }, []);
  useEffect(() => {
    // filteredWebinar
    if (webinars.data && webinars.data.length > 0) {
      return setFilteredWebinar((prev) => {
        return {
          upcoming: webinars.data.filter(
            ({ status }) => status !== Webinar_status.ENDED
          ),
          past: webinars.data.filter(
            ({ status }) => status === Webinar_status.ENDED
          ),
        };
      });
    } else {
      // return [];
      return setFilteredWebinar({ upcoming: [], past: [] });
    }
  }, [webinars]);

  useEffect(() => {
    if (showAllSpeakers?.show || inviteModal?.show) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showAllSpeakers.show, inviteModal.show]);

  const handleInviteBtnClose = () => {
    setInviteModal({ show: false, webinarIndex: 0 });
  };

  const handleInviteBtn = (index) => {
    addGAWithUserInfo(HOME_UPCOMING_WEBINAR_SHARE_CLICK, {
      eventId: webinars.data[inviteModal.webinarIndex].id,
    });
    setInviteModal({ show: true, webinarIndex: index });
  };

  const handleShowSpeakers = (speakersList, index) => {
    setShowAllSpeakers({ show: true, speakerIndex: index });
    setSpeakerCardList(speakersList);
  };

  const handleSpeakerClose = () => {
    setShowAllSpeakers({ show: false, speakerIndex: 0 });
  };
  const isUserRegisteredWebinar = useCallback(
    (webinarID) => {
        // console.log(webinarID,userMetadata);
      if (userMetadata?.id && userMetadata?.webinars) {
        const isRegistered = userMetadata.webinars.indexOf(webinarID) !== -1;
        return isRegistered;
      }
    },
    [userMetadata]
  );

  // const lightXRef2 = useRef(null);
  // useEffect(() => {
  //   new Rellax(lightXRef2.current, {
  //     speed: 3,
  //     center: true,
  //     wrapper: null,
  //     round: true,
  //     vertical: true,
  //     horizontal: false,
  //   });
  // }, []);

  const handleAttendBtn = (webinarData) => {
    let pathname = `${WEBINAR_PAGE_ROUTE}/${webinarData.id}`;

    if (history.location.pathname === pathname) {
      return;
    }
    // // Call a function using these interfaces
    addCleverTapAnalytics(HOME_PAGE_CLICK_EVENT, {
      ...getWebinarClickData(webinarData),
      Section: "Upcoming Webinar",
    });

    addGAWithUserInfo(HOME_UPCOMING_WEBINAR_ATTEND_CLICK, {
      eventId: webinarData.id,
    });

    history.push({
      pathname: pathname,
      search: search,
    });
  };
  const handleViewMoreWebinarBtn = () => {
    history.push({
      pathname: WEBINAR_PAGE_ROUTE,
      search: search,
    });
  };
  const listToRender = useMemo(
    () =>
      filteredWebinar.upcoming.length <= 0
        ? filteredWebinar.past?.slice(0, 8)
        : filteredWebinar.upcoming,
    [filteredWebinar]
  );

  //For view more card in the past Webinar section, we are taking speakers list from the 1st and 2nd returned data
  const getSpeakerList = useMemo(() => {
    let uniqueSpeakers = new Set();
    filteredWebinar.past.forEach((w) => {
      w.speakersList.forEach((s) => {
        uniqueSpeakers.add(s);
      });
    });
    let uniqueSpeakersList = [...uniqueSpeakers].slice(0, 10);
    return uniqueSpeakersList;
  }, [filteredWebinar]);

  const [nextActive, setNextActive] = useState(true);
  useEffect(() => {
    if (
      filteredWebinar.upcoming.length > 2 &&
      currentIndex < filteredWebinar.upcoming.length &&
      currentIndex < Math.min(7, filteredWebinar.upcoming.length - 2)
    ) {
      setNextActive(true);
    } else if (
      filteredWebinar.upcoming.length == 0 &&
      filteredWebinar.past.length > 2 &&
      currentIndex < filteredWebinar.past.length &&
      currentIndex < Math.min(7, filteredWebinar.past.length - 2)
    ) {
      setNextActive(true);
    } else {
      setNextActive(false);
    }
  }, [currentIndex, filteredWebinar]);

  return !webinars.data ? (
    <div className={styles.sectionWrapper} style={{ marginTop: "1rem" }}>
      <div className={styles.container}>
        <div className={styles.webinarWrapper} id="upcoming">
          <Shimmer
            loading={true}
            loadingComponent={[...Array(2)].map((item, index) => (
              <Box
                key={index}
                height={410}
                width={isMobileDevice ? "50%" : "70%"}
                marginRight={index === 1 ? 0 : 24}
              ></Box>
            ))}
          />
        </div>
      </div>
    </div>
  ) : (
    <div className={styles.sectionWrapper} style={{ marginTop: "1rem" }}>
      <AnimatedHeader
        mainHeader={`${
          filteredWebinar.upcoming.length <= 0 ? "Past" : "Upcoming"
        } Webinars`}
        imageHeader={WebinarText}
        offset={3700}
        imageHeaderOffset={80}
      />

      <div className={styles.container}>
        {/* <div className={styles.plusIconLight} ref={lightXRef2}>
        <img src={lightX} alt="" />
      </div> */}
        <div className={styles.webinarWrapper} id="upcoming">
          {listToRender.map((element, index) => {
            const { speakersList = [] } = element;
            return (
              <div
                className={styles.cardAndImgWrapper}
                id={`upcomingCard${index}`}
                key={index}
              >
                <div
                  onClick={() => handleAttendBtn(element)}
                  className={styles.upcomingCard}
                  // data-aos={isMobileDevice ? "fade-left" : "fade-up"}
                  // data-aos-delay={index * 100}
                  // data-aos-offset="-200"
                  style={{
                    backgroundBlendMode: "multiply",
                    background: true
                      ? `linear-gradient(180deg, rgba(0, 0, 0, 0.94) 0%, rgba(0, 0, 0, 0.00) 47.5%, rgba(0, 0, 0, 0.94) 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.51) 0%, rgba(0, 0, 0, 0.51) 100%),
            url(${
              isMobileDevice
                ? element.thumbSquareMobileUrl ?? element.thumbnailUrl
                : element.thumbSquareUrl ?? element.thumbnailUrl
            }) lightgray -336.954px 0px / 135.578% 100% no-repeat`
                      : `linear-gradient(180deg, rgba(0, 0, 0, 0.94) 0%, rgba(0, 0, 0, 0.00) 47.5%, rgba(0, 0, 0, 0.94) 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.51) 0%, rgba(0, 0, 0, 0.51) 100%), url(${element.thumbnailUrl}) lightgray -336.954px 0px / 135.578% 100% no-repeat`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                  }}
                >
                  <div className={styles.title}>{element.title}</div>
                  {/* <div className={styles.count}></div> */}
                  <div className={styles.webinarDate}>
                    {moment(
                      new Date(element.startTime.toDate()).toUTCString()
                    ).format("Do MMMM, YY - hh:mmA")}
                  </div>

                  <div className={styles.actionBtns}>
                    {speakersList.length > 0 && (
                      <Speakers
                        speakersList={speakersList}
                        handleShowSpeakers={handleShowSpeakers}
                        index={index}
                      />
                    )}
                    <div className={styles.leftWrapper}>
                      <div
                        className={styles.attendBtn}
                        onClick={() => handleAttendBtn(element)}
                      >
                        {element.status === Webinar_status.ONGOING
                          ? "Attend"
                          : element.status === Webinar_status.ENDED
                          ? "View"
                          : isUserRegisteredWebinar(element?.id) ? "Registered" : "Register"
                        }
                      </div>
                      {user && (
                        <div
                          onClick={(e) => {
                            e.stopPropagation();
                            handleInviteBtn(index);
                          }}
                          className={styles.shareBtn}
                        >
                          <img src={shareIcon} alt="share" />
                          Share
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                {showAllSpeakers.show &&
                showAllSpeakers.speakerIndex === index ? (
                  <AllSpeakers
                    webinar={true}
                    key={index}
                    index={showAllSpeakers.speakerIndex}
                    speakerCardList={speakerCardList}
                    handleSpeakerClose={handleSpeakerClose}
                  />
                ) : null}
              </div>
            );
          })}

          {inviteModal.show && (
            <InviteModal
              from={ContentType2.Webinar}
              type="event"
              details={webinars.data[inviteModal.webinarIndex]}
              handleClose={handleInviteBtnClose}
              customClass={"inviteModal"}
            />
          )}
          {
            //Display View More card only if Upcoming Webinar count is 0 and Past webinar count is more
            //than 8 because by default we are showing 8 cards in past webinars
            webinars.data &&
              webinars.data.length > 0 &&
              filteredWebinar.past.length > 8 &&
              filteredWebinar.upcoming.length <= 0 && (
                <div
                  className={styles.cardAndImgWrapper}
                  id={`upcomingCard${listToRender.length}`}
                  key={listToRender.length}
                >
                  <div
                    className={styles.upcomingCard}
                    data-aos={isMobileDevice ? "fade-left" : "fade-up"}
                    data-aos-delay={listToRender.length * 100}
                    data-aos-offset="-200"
                    style={{
                      backgroundBlendMode: "multiply",
                      background: `linear-gradient(180deg, rgba(0, 0, 0, 0.94) 0%, rgba(0, 0, 0, 0.00) 47.5%, rgba(0, 0, 0, 0.94) 100%), linear-gradient(0deg, rgba(0, 0, 0, 0.51) 0%, rgba(0, 0, 0, 0.51) 100%), url(${DOCFLIX_WEBINAR_BACKGROUND_IMAGE}) lightgray -336.954px 0px / 135.578% 100% no-repeat`,
                      backgroundSize: "cover",
                      backgroundPosition: "right center",
                    }}
                    onClick={handleViewMoreWebinarBtn}
                  >
                    <div className={styles.viewmoreRow}>
                      <div className={styles.viewmoreText}>
                        View All Webinars
                      </div>
                      <div className={styles.viewmoreBtn}>
                        <svg
                          width="25"
                          height="42"
                          viewBox="0 0 31 53"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.30164 3.82165L26.8108 26.3308L4.30164 48.84"
                            stroke="white"
                            strokeWidth="7.50305"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                    <div className={styles.actionBtns}>
                      {getSpeakerList && getSpeakerList.length > 0 && (
                        <Speakers
                          speakersList={getSpeakerList}
                          handleShowSpeakers={handleShowSpeakers}
                          index={0}
                        />
                      )}
                    </div>
                  </div>
                </div>
              )
          }
        </div>
        {!isMobileDevice &&
          (filteredWebinar.upcoming.length <= 0
            ? filteredWebinar.past.length > 2
            : filteredWebinar.upcoming.length > 2) && (
            <SliderControls
              onPrev={() => updateIndex(currentIndex - 1)}
              onNext={() => updateIndex(currentIndex + 1)}
              prevActive={currentIndex > 0}
              nextActive={nextActive}
              customClass={styles.slider}
              leftarrow={arrowLeft}
              rightArrow={arrowRight}
            />
          )}
      </div>
    </div>
  );
}

export default memo(UpcomingWebinars);
// filteredWebinar.length <= 0 ?
//   <div
//     className={`${styles.webinarWrapper} ${styles.comingSoonWrapperWrapper}`}
//     id="upcoming"
//   >
//     <ComingSoonWebinarCard />
//   </div>
